export default () => {
    const route = useRoute()

    const path = route.path.substring(1)

    if (!path) {
        return 'home'
    }

    const pieces = path.split('/')

    return pieces[pieces.length - 1]
}
